import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { LocationsCountersHttpClient } from './locations-counters.http-client';
import { LocationCountersActions } from './locations-counters.store';

@Injectable({ providedIn: 'root' })
export class LocationsCountersEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(LocationsCountersHttpClient);

  public effects = createEffectFactory(LocationCountersActions, this.actions$);

  public fetch$ = this.effects(LocationCountersActions.fetch, () =>
    this.http.fetch().pipe(map(data => data.counters)),
  );
}
